{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Izveidot jaunu komandu",
    "HEADER": "Komandas",
    "LOADING": "Notiek komandu iegūšana",
    "DESCRIPTION": "Komandas ļauj organizēt aģentus grupās, pamatojoties uz viņu pienākumiem. Aģents var piederēt vairākām komandām. Kad strādājat sadarbojoties, varat piešķirt sarunas noteiktām komandām.",
    "LEARN_MORE": "Uzzināt vairāk par komandām",
    "COUNT": "{n} team | {n} teams",
    "SEARCH_PLACEHOLDER": "Meklēt komandas...",
    "NO_RESULTS": "No teams found matching your search",
    "LIST": {
      "404": "Šajā kontā nav izveidota neviena komanda.",
      "EDIT_TEAM": "Rediģēt komandu",
      "NONE": "Nav"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Izveidojiet jaunu komandu",
        "DESC": "Pievienot savai jaunajai komandai nosaukumu un aprakstu."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Pievienot komandai aģentus",
        "TITLE": "Pievienot aģentus komandai - {teamName}",
        "DESC": "Pievienot aģentus savai jaunizveidotajai komandai. Tas ļauj sarunās sadarboties kā komandai, kā arī saņemt paziņojumus par jauniem notikumiem tajā pašā sarunā."
      },
      "WIZARD_CREATE": {
        "TITLE": "Izveidot",
        "BODY": "Izveidot jaunu aģentu komandu."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Pievienot Aģentus",
        "BODY": "Pievienot komandai aģentus."
      },
      "WIZARD_FINISH": {
        "TITLE": "Pabeigt",
        "BODY": "Jūs varat sākt darboties!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Rediģēt savas komandas informāciju",
        "DESC": "Rediģēt savas komandas nosaukumu un aprakstu.",
        "BUTTON_TEXT": "Atjaunināt komandu"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Atjaunināt aģentus komandā",
        "TITLE": "Pievienot aģentus komandai - {teamName}",
        "DESC": "Pievienot aģentus savai jaunizveidotajai komandai. Visi pievienotie aģenti tiks informēti, kad saruna tiks piešķirta šai komandai."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Komandas informācija",
        "ROUTE": "settings_teams_edit",
        "BODY": "Mainīt nosaukumu, aprakstu un citu informāciju."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Rediģēt Aģentus",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Rediģēt savas komandas aģentus."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Pabeigt",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Jūs varat sākt darboties!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Nevarēja saglabāt komandas informāciju. Lūdzu, mēģiniet vēlreiz."
    },
    "AGENTS": {
      "AGENT": "Aģents",
      "EMAIL": "E-pasts",
      "BUTTON_TEXT": "Pievienot aģentus",
      "ADD_AGENTS": "Notiek aģentu pievienošana Jūsu komandai...",
      "SELECT": "izvēlēties",
      "SELECT_ALL": "izvēlēties visus aģentus",
      "SELECTED_COUNT": "{selected} no {total} aģentiem ir atlasīti."
    },
    "ADD": {
      "TITLE": "Pievienot aģentus komandai - {teamName}",
      "DESC": "Pievienot aģentus savai jaunizveidotajai komandai. Tas ļauj sarunās sadarboties kā komandai, tā arī saņemt paziņojumus par jauniem notikumiem tajā pašā sarunā.",
      "SELECT": "izvēlēties",
      "SELECT_ALL": "izvēlēties visus aģentus",
      "SELECTED_COUNT": "{selected} no {total} aģentiem ir atlasīti.",
      "BUTTON_TEXT": "Pievienot aģentus",
      "AGENT_VALIDATION_ERROR": "Izvēlieties vismaz vienu aģentu."
    },
    "FINISH": {
      "TITLE": "Jūsu komanda ir gatava!",
      "MESSAGE": "Tagad Jūs sarunās varat sadarboties kā komanda. Laimīgu atbalstu ",
      "BUTTON_TEXT": "Pabeigt"
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "API": {
        "SUCCESS_MESSAGE": "Komanda ir veiksmīgi izdzēsa.",
        "ERROR_MESSAGE": "Nevarēja izdzēst komandu. Lūdzu, mēģiniet vēlreiz."
      },
      "CONFIRM": {
        "TITLE": "Vai tiešām vēlaties dzēst komandu?",
        "PLACE_HOLDER": "Lūdzu, uzrakstiet {teamName} lai apstiprinātu",
        "MESSAGE": "Komandas dzēšana noņems komandas uzdevumu no sarunām, kas piešķirtas šai komandai.",
        "YES": "Dzēst ",
        "NO": "Atcelt"
      }
    },
    "SETTINGS": "Iestatījumi",
    "FORM": {
      "UPDATE": "Atjaunināt komandu",
      "CREATE": "Izveidot komandu",
      "NAME": {
        "LABEL": "Komandas nosaukums",
        "PLACEHOLDER": "Piemēram: Pārdošana, Klientu Atbalsts"
      },
      "DESCRIPTION": {
        "LABEL": "Komandas Apraksts",
        "PLACEHOLDER": "Īss apraksts par šo komandu."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Atļaut automātiskai piešķirt šai komandai."
      },
      "SUBMIT_CREATE": "Izveidot komandu"
    }
  }
}
